import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../Styles/claimManagement";
import AutoComplete from "../../components/Comman/AutoComplete";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import React from "react";
import { taBeatDoesNotHaveTAAmount } from "../../config/messageconstant";

const AllowanceWiseClaimManagementTable = ({
    matrixDataList,
    handleAllCheckedClick,
    clickSubmitHandler,
    clickDeleteHandler,
    clickApproveHandler,
    clickRejectHandler,
    allChecked,
    handleCheckBoxClick,
    onAutocompleteChange,
    changeHandler,
    changeRadioHandler,
    handleStatusChange,
}) => {

    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {
            let isValid = false;
            let dates =
                currentRow.dates != null ? currentRow.dates : "";
            let daBeatName =
                currentRow.daBeatName != null ? currentRow.daBeatName : "";
            let daClaimAmount =
                currentRow.daClaimAmount != null ? currentRow.daClaimAmount : "";
            let taBeatName =
                currentRow.taBeatName != null ? currentRow.taBeatName : "";
            let taClaimAmount =
                currentRow.taClaimAmount != null ? currentRow.taClaimAmount : "";
            let totalClaimAmt =
                currentRow.totalClaimAmt != null ? currentRow.totalClaimAmt : "";
            let status =
                currentRow.status != null && currentRow.status !== undefined ?
                    (currentRow.status == 0 ? "Pending"
                        : currentRow.status == 1 ? "Cancelled"
                            : currentRow.status == 2 ? "Approved"
                                : "Rejected")
                    : "Claim Not Applied";

            if (
                dates &&
                dates.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            if (
                daBeatName &&
                daBeatName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            if (
                daClaimAmount &&
                daClaimAmount.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } if (
                taBeatName &&
                taBeatName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } if (
                taClaimAmount &&
                taClaimAmount.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } if (
                totalClaimAmt &&
                totalClaimAmt.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } if (
                status &&
                status.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    return (
        <>
            <LandingScreenHeader
                screenTitle={""}
                showSearchBox={true}
                showTable={true}
                showFilter={false}
                showPdfDownload={false}
                showExcelDownload={false}
                onSearch={onSearchValue}
            />

            <div
                style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "500px",
                    position: "relative",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    <thead
                        style={{
                            position: "sticky",
                            top: 0,
                            background: "#03a9f4",
                            zIndex: 3,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <tr>
                            <th
                                style={{
                                    ...claimManagementStyles.tableHeadStyle,
                                    minWidth: "60px",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={allChecked}
                                    style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                        accentColor: allChecked ? "#f44336" : "#03a9f4"
                                    }}
                                    onChange={handleAllCheckedClick}
                                />
                            </th>

                            {/* Date Column */}
                            <th
                                style={{
                                    ...claimManagementStyles.tableHeadStyle,
                                    minWidth: "130px",
                                }}
                            >
                                Date
                            </th>

                            {/* DA Beat */}
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "250px", }}>
                                DA Beat
                            </th>

                            {/* DA Amt */}
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                DA Amt
                            </th>

                            {/* TA Beat */}
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "250px", }}>
                                TA Beat
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "130px", width: "130px" }}>
                                Dist. (Km)
                            </th>

                            {/* TA Amt */}
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                TA Amt
                            </th>



                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "270px", }}>
                                Type
                            </th>

                            {/* Total */}
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                Total
                            </th>

                            {/* Status */}
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                Status
                            </th>
                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {getFilteredTableData(matrixDataList).map((team) => (
                            <tr key={team.id}>

                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "center",
                                    }}
                                >

                                    <input
                                        type="checkbox"
                                        style={{
                                            transform: "scale(1.5)",
                                            margin: "0 8px",
                                        }}
                                        checked={team.isChecked}
                                        onChange={(e) =>
                                            handleCheckBoxClick(e, team.id)
                                        }
                                    />
                                </td>

                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "center",
                                    }}
                                >
                                    {team.dates !== null ? team.dates : ""}
                                </td>
                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "left",
                                        lineHeight: 0.7,
                                    }}
                                >
                                    <AutoComplete
                                        key={team.id}
                                        name="daBeat"
                                        label="DA Beat"
                                        placeHolder="Select DA Beat"
                                        keyColName="id"
                                        options={team.workingBeatsWithCalculation}
                                        value={team.selectedDaBeat}
                                        onChange={onAutocompleteChange(team.id)}
                                        style={{ margin: 0 }}
                                        isError={false}
                                        errorText=""
                                    />
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    {team.daClaimAmount && team.daClaimAmount !== null ? team.daClaimAmount.toFixed(2) : 0}
                                </td>
                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "left",
                                        lineHeight: 0.7,
                                    }}
                                >
                                    {team.isManuallyEdited == 1 ? (
                                        <TextFieldCompo
                                            placeHolder="TA Beat"
                                            color="primary"
                                            name="manuallyEditedBeatName"
                                            id={`manuallyEditedBeatName-${team.id}`}
                                            size="small"
                                            value={team.manuallyEditedBeatName}
                                            fullWidth
                                            onChange={changeHandler(
                                                team,
                                                "manuallyEditedBeatName"
                                            )}
                                            errorText={team.manuallyEditedBeatNameError || ""}
                                        />
                                    ) : (
                                        <AutoComplete
                                            key={team.id}
                                            name="taBeat"
                                            label="taBeat"
                                            placeHolder="Select TA Beat"
                                            keyColName="id"
                                            value={team.selectedTaBeat}
                                            options={team.nonWorkingBeatsWithCalculation}
                                            onChange={onAutocompleteChange(team.id)}
                                            isError={team.isZeroAmtOnTaBeatError}
                                            errorText={
                                                team.isZeroAmtOnTaBeatError ?
                                                    taBeatDoesNotHaveTAAmount : ""
                                            }
                                        />
                                    )
                                    }
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    {team.isManuallyEdited == 1 ? (
                                        <TextFieldCompo
                                            placeHolder="Distance"
                                            color="primary"
                                            type="number"
                                            onWheel={(e) => e.target.blur()}
                                            name="manuallyEditedDistance"
                                            id={`manuallyEditedDistance-${team.id}`}
                                            size="small"
                                            value={team.manuallyEditedDistance}
                                            fullWidth
                                            onChange={changeHandler(
                                                team,
                                                "manuallyEditedDistance"
                                            )}
                                            errorText={team.manuallyEditedDistanceError || ""}
                                        />
                                    ) : (team.distanceFromHq && team.distanceFromHq !== null ? team.distanceFromHq : 0)}

                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    {team.isManuallyEdited == 1 ?
                                        (team.manuallyEditedClaimAmount && team.manuallyEditedClaimAmount !== null ? Number(team.manuallyEditedClaimAmount).toFixed(2) : 0)
                                        : (team.taClaimAmount && team.taClaimAmount !== null ? Number(team.taClaimAmount).toFixed(2) : 0)}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle }}>
                                    <RadioGroup
                                        row
                                        aria-label="Type"
                                        name="typy"
                                        id={`typy-${team.id}`}
                                        value={team.isManuallyEdited}
                                        onChange={(event) =>
                                            changeRadioHandler(
                                                event,
                                                team.id
                                            )
                                        }
                                        size="small"
                                    >
                                        <FormControlLabel
                                            value={0}
                                            control={<Radio />}
                                            label="Normal"
                                        />
                                        <FormControlLabel
                                            value={1}
                                            control={<Radio />}
                                            label="Manual Edit"
                                        />
                                    </RadioGroup>
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    {team.totalClaimAmt != null ? Number(team.totalClaimAmt).toFixed(2) : "0.00"}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "left" }}>
                                    {team.status !== null && team.status !== undefined
                                        ? (team.status == 0 ? "Pending"
                                            : team.status == 1 ? "Cancelled"
                                                : team.status == 2 ? "Approved"
                                                    : "Rejected")
                                        : "Claim Not Applied"}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, verticalAlign: "middle", textAlign: "center" }}>
                                    {team.status == 0 ? (
                                        <div style={{
                                            display: "flex",
                                            gap: "12px",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>
                                            {/* Approve Icon */}
                                            <div
                                                onClick={() => handleStatusChange(team.id, 2)}
                                                style={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "32px",
                                                    height: "32px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#e8f5e9",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#4CAF50";
                                                    e.currentTarget.querySelector('svg').style.fill = "white";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#e8f5e9";
                                                    e.currentTarget.querySelector('svg').style.fill = "#4CAF50";
                                                }}
                                                title="Approve Claim"
                                            >
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="#4CAF50"
                                                    style={{ transition: "fill 0.3s ease" }}
                                                >
                                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                                </svg>
                                            </div>

                                            {/* Reject Icon */}
                                            <div
                                                onClick={() => handleStatusChange(team.id, 3)}
                                                style={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "32px",
                                                    height: "32px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#ffebee",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#f44336";
                                                    e.currentTarget.querySelector('svg').style.fill = "white";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#ffebee";
                                                    e.currentTarget.querySelector('svg').style.fill = "#f44336";
                                                }}
                                                title="Reject Claim"
                                            >
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="#f44336"
                                                    style={{ transition: "fill 0.3s ease" }}
                                                >
                                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                </svg>
                                            </div>
                                        </div>
                                    ) : null}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <br />
            <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="flex-end"
                gap={2}
            >
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Approve Claim"}
                    onClick={clickApproveHandler}
                    fullWidth={false}
                />
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Reject Claim"}
                    onClick={clickRejectHandler}
                    fullWidth={false}
                />
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Delete Claim"}
                    onClick={clickDeleteHandler}
                    fullWidth={false}
                />
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Submit"}
                    onClick={clickSubmitHandler}
                    fullWidth={false}
                />
            </Grid>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllowanceWiseClaimManagementTable);
